import GalleryElement from './GalleryElement';
import GalleryElementDefinition from './GalleryElementDefinition';
import GalleryElementMetaData from './GalleryElementMetaData';

export default {
  GalleryElement: GalleryElement,
  GalleryElementDefinition: GalleryElementDefinition,
  GalleryElementType: GalleryElementMetaData.type
};
